import { flexRender } from "@tanstack/react-table";
import { TrendsType } from "reedy-data/models";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "components/table";
import { useMemo } from "react";
import { useTrends } from "contexts/TrendsContext";
import { useTable } from "hooks/useTable";
import { useTranslation } from "react-i18next";
import { getColumns } from "./columns";
import { PreHeader } from "./preHeader";
import { SearchTermsTableBody } from "./SearchTermsTableBody";
import { SearchTermsAmazonEmpty } from "./SearchTermsAmazonEmpty";

export const SearchTermsTable = () => {
  const { t } = useTranslation(["searchTerms"]);
  const {
    trendsWithProducts = [],
    isLoadingTrends,
    selectedTrendsType,
  } = useTrends();

  const columns = useMemo(() => getColumns(t), [t]);
  const hasProducts = trendsWithProducts?.length > 0;
  const isEmptyAmazon =
    selectedTrendsType === TrendsType.AMAZON &&
    !hasProducts &&
    !isLoadingTrends;

  const { table } = useTable({
    columns,
    data: trendsWithProducts,
    enableRowSelection: true,
    totalRecords: trendsWithProducts?.length || 0,
    getRowId: (row, index) => row.id ?? String(index),
  });

  return (
    <div className="space-y-4 text-left">
      <PreHeader table={table} isEmptyAmazon={isEmptyAmazon} />
      {isEmptyAmazon ? (
        <SearchTermsAmazonEmpty />
      ) : (
        <Table>
          <TableHeader>
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <TableHead
                    key={header.id}
                    colSpan={header.colSpan}
                    style={{ width: header.getSize() || undefined }}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                  </TableHead>
                ))}
              </TableRow>
            ))}
          </TableHeader>

          <TableBody>
            <SearchTermsTableBody table={table} isLoading={isLoadingTrends} />
          </TableBody>
        </Table>
      )}
    </div>
  );
};
